// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"188":"Body-Body","262":"reactPlayerHls","723":"reactPlayerMux"}[chunkId] || chunkId) + "." + {"188":"36768629231cc5ce1244","262":"d99d9a2baab0d849c888","484":"5753c5387b601798a363","723":"1d56aedc667d87fab2b2"}[chunkId] + ".bundle.js";
};